import { render, staticRenderFns } from "./DividendSettingManual.vue?vue&type=template&id=176376fc&scoped=true"
import script from "./DividendSettingManual.vue?vue&type=script&lang=js"
export * from "./DividendSettingManual.vue?vue&type=script&lang=js"
import style0 from "./DividendSettingManual.vue?vue&type=style&index=0&id=176376fc&prod&lang=scss&scoped=true"
import style1 from "./DividendSettingManual.vue?vue&type=style&index=1&id=176376fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176376fc",
  null
  
)

export default component.exports